// extracted by mini-css-extract-plugin
module.exports = {"component":"CartWidget_component__4QrJC"};